<template>
    <div class="pt15">
        <div class="sub_title">
           메모
            <div class="fs13 input_error pl0">메모 수정시 해당 주문 번호 내 모든 상품에 대해 일괄 변경 됩니다.</div>
        </div>
        <div class="c_table_wrap">
            <div class="d_block">
                <el-input type="textarea" v-model="detailMemo" rows="5" @change="parentChange('detailMemo', detailMemo)"
                          resize="none" placeholder="메모를 입력해주세요."></el-input>
            </div>
        </div>
    </div>
</template>

<script>

import util from "@/mixins/util";
import SimpleVueValidation from "simple-vue-validator";
import Vue from "vue";
const Validator = SimpleVueValidation.Validator;
import EventBus from "../../../../mixins/event-bus";

Vue.use(SimpleVueValidation);
export default {
    name: "OrderMemoLayout",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {
        }
    },
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        orderData: {
            default: () => {
            }, type: Object
        },
        orderClass: {default: null,},
    },
    data() {
        return {
            detailMemo:'',
            validatorArr: ['detailMemo'],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initData()
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('OrderMemoLayout')
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initData(){
            if(!util.isEmpty(this.orderData)){
                this.detailMemo = this.orderData.detailMemo
            }
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkValidator() {
            this.$validate(['detailMemo'])
        }
    },
    watch: {},
    validators: {
        detailMemo: function (value) {
            return Validator.value(value)
        },
    }
}
</script>

<style scoped>

</style>
